import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { BuyButton } from "./BuyButton";
import { IMAGES } from "./constants";

const CREDENTIALS = [
  "Four-time author, including Navigating a Toxic Workplace for Dummies (Wiley)",
  "TEDx speaker with thousands of hours on stage across 15 countries",
  "LinkedIn Learning author of 60+ courses, translated into 11 languages, viewed by 3M+ learners",
  "LinkedIn Top Voice in Culture Change, with 70,000+ followers",
  "Award-winning thought leader recognized by 40+ institutions",
  "Featured on CNN and NPR; cited in Forbes, Inc., USA Today, WSJ, and LA Times",
  "Founder of Civility Partners — nearly 300 clients served in culture-change initiatives",
];

export const Founder = () => (
  <section id="catherine" className="py-24 lg:py-32" data-testid="founder-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 lg:grid-cols-12 lg:px-10">
      <Reveal className="lg:col-span-7">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">Meet your mentor</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
          Built by Catherine Mattice — the voice of civility at work.
        </h2>
        <p className="mt-6 max-w-2xl leading-relaxed text-navy/70 md:text-lg">
          A world-renowned, award-winning speaker, author, and entrepreneur, Catherine has spent
          her career helping organizations transform toxicity into trust. This toolkit packages
          the exact program her team delivers to clients — so you can bring that same caliber of
          training to every room you lead.
        </p>
        <ul className="mt-8 space-y-3.5" data-testid="founder-credentials">
          {CREDENTIALS.map((c) => (
            <li key={c} className="flex items-start gap-3 text-navy/80">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage/60">
                <Check className="h-3.5 w-3.5 text-navy" aria-hidden="true" />
              </span>
              <span className="leading-relaxed">{c}</span>
            </li>
          ))}
        </ul>
        <BuyButton testId="founder-buy-button" className="mt-10">Train Like Catherine — $249</BuyButton>
      </Reveal>

      <Reveal className="lg:col-span-5" delay={0.1}>
        <div className="overflow-hidden rounded-[2rem] border border-navy/10 shadow-[0_40px_80px_-30px_rgba(15,23,42,0.3)]">
          <img src={IMAGES.founder} alt="Catherine Mattice, founder of Civility Partners" className="h-[520px] w-full object-cover object-top" loading="lazy" data-testid="founder-photo" />
        </div>
      </Reveal>
    </div>
  </section>
);
